import { Controller } from "@hotwired/stimulus"

// Genera un'immagine con l'AI (nano-banana) e la inserisce inline nell'editor Lexxy
// della sezione, esattamente come fa mermaid-insert: uploadFile crea un allegato
// ActionText nel corpo, così l'immagine compare nel documento e nel PDF.
export default class extends Controller {
  static targets = ["dialog", "prompt", "status", "generate"]
  static values = { url: String }

  open() {
    // Ricorda l'editor prima che il dialog rubi il focus.
    this._editor = this.element.querySelector("lexxy-editor")
    this.clearStatus()
    this.dialogTarget.showModal()
    this.promptTarget.focus()
    this.promptTarget.setSelectionRange(this.promptTarget.value.length, this.promptTarget.value.length)
  }

  close() {
    this.dialogTarget.close()
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  async generate() {
    if (!this._editor?.contents) {
      this.showError(this.statusTarget.dataset.errorEditor)
      return
    }

    this.setLoading(true)
    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
          "Content-Type": "application/json",
          "Accept": "image/png"
        },
        body: JSON.stringify({ prompt: this.promptTarget.value.trim() })
      })
      if (!response.ok) throw new Error(`HTTP ${response.status}`)

      const blob = await response.blob()
      const file = new File([blob], "illustrazione-ai.png", { type: blob.type || "image/png" })

      this._editor.focus()
      await new Promise(r => setTimeout(r, 50))
      this._editor.contents.uploadFile(file)
      this.close()
    } catch (error) {
      console.error("AI image generation failed:", error)
      this.showError(this.statusTarget.dataset.errorGeneric)
    } finally {
      this.setLoading(false)
    }
  }

  setLoading(on) {
    this.generateTarget.disabled = on
    this.promptTarget.disabled = on
    if (on) {
      this._error = false
      this.statusTarget.innerHTML =
        '<span class="inline-block h-4 w-4 rounded-full border-2 border-primary/30 border-t-primary animate-spin align-[-2px] mr-1"></span>' +
        this.statusTarget.dataset.generating
    } else if (!this._error) {
      this.clearStatus()
    }
  }

  showError(message) {
    this._error = true
    this.statusTarget.textContent = message
    this.statusTarget.classList.add("text-error")
  }

  clearStatus() {
    this._error = false
    this.statusTarget.textContent = ""
    this.statusTarget.classList.remove("text-error")
  }
}
